var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { "is-modified": !!_vm.value, label: "性別", half: "" } },
    _vm._l(_vm.genderOptions, function (gender, i) {
      return _c(
        "label",
        { key: i, staticClass: "pega-badge-radio pega-mr-5" },
        [
          _c("input", {
            attrs: { "data-test": "gender-" + gender.id, type: "radio" },
            domProps: { checked: _vm.value === gender.id, value: gender.id },
            on: {
              change: function ($event) {
                return _vm.$emit("input", $event.target._value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "pega-badge-radio-text pega-badge-radio-check-mark",
              attrs: { "data-test": "gender-name-" + gender.id },
            },
            [_vm._v(_vm._s(gender.name))]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }